export enum MarketName {
  US_MARKET = 'US Market',
  EUROPEAN_MARKET = 'European Market',
  APAC_MARKET = 'APAC Market',
  EMERGING_MARKET = 'Emerging Market',
}

export enum MarketAbbreviations {
  US_MARKET = 'US',
  EUROPEAN_MARKET = 'European',
  APAC_MARKET = 'APAC',
  EMERGING_MARKET = 'EM',
}
